document.addEventListener('DOMContentLoaded', function() {
    const flavourBlock = document.querySelector('.nw-flavour-block');
    const flavourInputs = document.querySelectorAll('.nw-flavour-block__Flavour-item input[name="flavour"]');
    const packSection = document.querySelector('.nw-flavour-block__Flavour-pack');
    const packInputs = document.querySelectorAll('.nw-flavour-block__Flavour-pack-item input[name="pack"]');
    const addToCartBtn = document.querySelector('.nw-flavour-block__Flavour-add-to-cart button');
    const ctaRegularPrice = document.querySelector('.cta-regular-price');
    const ctaDiscountPrice = document.querySelector('.cta-discount-price');
    const selectedFlavourLabel = document.querySelector('.selected-flavour-label');
    const selectedPackLabel = document.querySelector('.selected-pack-label');
    const dynamicDescItems = document.querySelectorAll('.nw-flavour-block__dynamic-description-item');
    const galleryItems = document.querySelectorAll('.flavour-media-gallery');
    const purchaseTypeInputs = document.querySelectorAll('input[name="purchase_type"]');
    
    // Initial setup
    updateUI();
    
    // Initialize pack content visibility
    const initialSelectedPack = document.querySelector('input[name="pack"]:checked');
    if (initialSelectedPack) {
      updatePackContent(initialSelectedPack);
    }
    
    // Initialize purchase type content visibility
    const initialSelectedPurchaseType = document.querySelector('input[name="purchase_type"]:checked');
    if (initialSelectedPurchaseType) {
      updatePurchaseTypeContent(initialSelectedPurchaseType);
    }

    // Event listeners
    flavourInputs.forEach(input => {
      input.addEventListener('change', function() {
        updateUI();
        updateDynamicDescription(this);
        updateSelectedFlavourLabel(this);
      });
    });

    packInputs.forEach(input => {
      input.addEventListener('change', function() {
        updateUI();
        updateSelectedPackLabel(this);
        updatePackContent(this);
      });
    });

    purchaseTypeInputs.forEach(input => {
      input.addEventListener('change', function() {
        updateUI();
        updatePurchaseTypeContent(this);
      });
    });

    addToCartBtn.addEventListener('click', addToCart);

    // Functions
    function updateUI() {
      const selectedFlavour = document.querySelector('input[name="flavour"]:checked');
      const selectedPack = document.querySelector('input[name="pack"]:checked');
      
      // Check if pack should be disabled for this flavour
      if (selectedFlavour.hasAttribute('data-disable-pack')) {
        packSection.style.display = 'none';
      } else {
        packSection.style.display = 'block';
      }
      
      // Update pack item prices
      updatePackPrices(selectedFlavour);
      
      // Update CTA button prices
      updateCTAPrices(selectedFlavour, selectedPack);
      
      // Update labels
      updateSelectedFlavourLabel(selectedFlavour);
      if (selectedPack) {
        updateSelectedPackLabel(selectedPack);
      }
      
      // Update dynamic description
      updateDynamicDescription(selectedFlavour);
    }
    
    function updatePackPrices(selectedFlavour) {
      packInputs.forEach(input => {
        const packQty = input.value;
        const priceContainer = input.parentElement.querySelector('.nw-flavour-block__Flavour-pack-item-price');
        const regularPriceEl = priceContainer.querySelector('.nw-flavour-block__Flavour-pack-item-price-regular');
        const discountPriceEl = priceContainer.querySelector('.nw-flavour-block__Flavour-pack-item-price-discount');
        const discountTagEl = input.parentElement.querySelector('.nw-flavour-block__Flavour-pack-item-discount');
        
        // Get prices from the selected flavour data attributes
        const regularPrice = selectedFlavour.getAttribute(`data-${packQty}-pack-price`);
        const discountPrice = selectedFlavour.getAttribute(`data-${packQty}-pack-discount-price`);
        const discountPercentage = selectedFlavour.getAttribute(`data-${packQty}-pack-discount-percentage`);
        
        // Update price displays
        if (regularPrice) {
          if (discountPrice) {
            regularPriceEl.textContent = discountPrice;
            discountPriceEl.textContent = regularPrice;
            discountPriceEl.style.display = 'inline';
          } else {
            regularPriceEl.textContent = regularPrice;
            discountPriceEl.style.display = 'none';
          }
        }
      });
    }
    
    function updateCTAPrices(selectedFlavour, selectedPack) {
      let packQty = '1';
      
      if (!selectedFlavour.hasAttribute('data-disable-pack') && selectedPack) {
        packQty = selectedPack.value;
      }
      
      // Check if subscription is selected
      const selectedPurchaseType = document.querySelector('input[name="purchase_type"]:checked');
      const isSubscription = selectedPurchaseType && selectedPurchaseType.value === 'subscription';
      
      let regularPrice, discountPrice;
      
      if (isSubscription) {
        // Use subscription pricing
        regularPrice = selectedFlavour.getAttribute(`data-multiply-qty-${packQty}-pack-price`) || 
                      selectedFlavour.getAttribute(`data-${packQty}-pack-price`) ||
                      selectedFlavour.getAttribute('data-regular-price');
                      
        discountPrice = selectedFlavour.getAttribute(`data-multiply-qty-${packQty}-pack-subscription-discount-price`) || 
                       selectedFlavour.getAttribute(`data-${packQty}-pack-subscription-discount-price`);
      } else {
        // Use one-time pricing
        regularPrice = selectedFlavour.getAttribute(`data-multiply-qty-${packQty}-pack-price`) || 
                      selectedFlavour.getAttribute(`data-${packQty}-pack-price`) ||
                      selectedFlavour.getAttribute('data-regular-price');
                      
        discountPrice = selectedFlavour.getAttribute(`data-multiply-qty-${packQty}-pack-discount-price`) || 
                       selectedFlavour.getAttribute(`data-${packQty}-pack-discount-price`);
      }
      
      // Update CTA prices
      ctaRegularPrice.textContent = regularPrice;
      
      if (discountPrice) {
        ctaDiscountPrice.textContent = regularPrice;
        ctaRegularPrice.textContent = discountPrice;
        ctaDiscountPrice.style.display = 'inline';
      } else {
        ctaDiscountPrice.style.display = 'none';
      }
    }
    
    function updateDynamicDescription(selectedFlavour) {
      const flavourId = selectedFlavour.id;
      
      dynamicDescItems.forEach(item => {
        if (item.getAttribute('data-flavour-item') === flavourId) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
      
      // Update gallery visibility
      updateGallery(flavourId);
    }
    
    function updateGallery(flavourId) {
      // Look for gallery with ID that matches the selected flavour
      const galleryId = `gallery-${flavourId}`;
      
      galleryItems.forEach(gallery => {
        if (gallery.id === galleryId) {
          gallery.classList.add('active');
        } else {
          gallery.classList.remove('active');
        }
      });
    }
    
    function updateSelectedFlavourLabel(selectedFlavour) {
      const labelText = selectedFlavour.nextElementSibling.querySelector('.nw-flavour-block__Flavour-item-title-text').textContent.trim();
      selectedFlavourLabel.textContent = labelText;
    }
    
    function updateSelectedPackLabel(selectedPack) {
      const labelText = selectedPack.nextElementSibling.querySelector('.nw-flavour-block__Flavour-pack-item-title').textContent.trim();
      selectedPackLabel.textContent = labelText;
    }
    
    function updatePackContent(selectedPack) {
      const selectedPackIndex = Array.from(packInputs).indexOf(selectedPack) + 1;
      const targetPackAttr = `pack-${selectedPackIndex}`;
      
      // Find all elements with data-pack attributes
      const packElements = document.querySelectorAll('[data-pack]');
      
      packElements.forEach(element => {
        const elementPackAttr = element.getAttribute('data-pack');
        
        if (elementPackAttr === targetPackAttr) {
          // Show this element
          element.classList.remove('hidden');
        } else {
          // Hide other pack elements
          element.classList.add('hidden');
        }
      });
    }
    
    function updatePurchaseTypeContent(selectedPurchaseType) {
      const purchaseType = selectedPurchaseType.value;
      
      // Handle subscription vs one-time content visibility
      const subscriptionElements = document.querySelectorAll('[data-subscription-element]');
      const oneTimeElements = document.querySelectorAll('[data-one-time-element]');
      
      if (purchaseType === 'subscription') {
        // Show subscription elements, hide one-time elements
        subscriptionElements.forEach(el => el.classList.remove('hidden'));
        oneTimeElements.forEach(el => el.classList.add('hidden'));
      } else {
        // Show one-time elements, hide subscription elements
        subscriptionElements.forEach(el => el.classList.add('hidden'));
        oneTimeElements.forEach(el => el.classList.remove('hidden'));
      }
      
      // Update CTA pricing based on purchase type
      const selectedFlavour = document.querySelector('input[name="flavour"]:checked');
      const selectedPack = document.querySelector('input[name="pack"]:checked');
      if (selectedFlavour) {
        updateCTAPrices(selectedFlavour, selectedPack);
      }
    }
    
    function addToCart() {
      const selectedFlavour = document.querySelector('input[name="flavour"]:checked');
      const selectedPurchaseType = document.querySelector('input[name="purchase_type"]:checked');
      let quantity = 1;
      
      // Get quantity from selected pack if available
      if (!selectedFlavour.hasAttribute('data-disable-pack')) {
        const selectedPack = document.querySelector('input[name="pack"]:checked');
        if (selectedPack) {
          quantity = parseInt(selectedPack.value);
        }
      }
      
      const variantId = selectedFlavour.value;
      const purchaseType = selectedPurchaseType ? selectedPurchaseType.value : 'one-time';
      
      // Prepare cart item object
      const cartItem = {
        id: variantId,
        quantity: quantity
      };
      
      // Add selling plan for subscription purchases
      if (purchaseType === 'subscription') {
        const sellingPlanId = selectedFlavour.getAttribute('data-selling-plan-id');
        if (sellingPlanId) {
          cartItem.selling_plan = sellingPlanId;
        }
      }

      console.log('Adding to cart:', cartItem, 'Purchase type:', purchaseType);
      
      // Add loading state
      addToCartBtn.classList.add('loading');
      addToCartBtn.querySelector('.loading__spinner').classList.remove('hidden');
      
      // Add to cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [cartItem]
        })
      })
      .then(response => response.json())
      .then(data => {
        addToCartBtn.classList.remove('loading');
        addToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
        
        // Success - you can add redirect here if needed
        // window.location.href = '/checkout';
        
        // Refresh the cart drawer
        refreshCartDrawer();
      })
      .catch(error => {
        addToCartBtn.classList.remove('loading');
        console.error('Error adding to cart:', error);
      });
    }
    
    function refreshCartDrawer() {
      fetch(`${window.routes?.cart_url || '/cart'}?section_id=cart-drawer`)
        .then(response => {
          if (!response.ok) {
            throw new Error(`Failed to refresh cart drawer: ${response.status} ${response.statusText}`);
          }
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const parsedDocument = parser.parseFromString(html, 'text/html');
          const cartDrawer = document.querySelector('cart-drawer');
          const newCartDrawer = parsedDocument.querySelector('cart-drawer');
          
          if (cartDrawer && newCartDrawer) {
            cartDrawer.replaceWith(newCartDrawer); // Replace updated content
            newCartDrawer.classList.add('active'); // Add active class
          }
        })
        .catch(error => {
          console.error("Error during cart drawer refresh:", error);
        });
    }
  });